<template>
    <el-dialog
        ref="DetailDialog"
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        append-to-body
        class="payment-copy-dialog ah-detail-dialog"
        top="5vh"
        @open="onOpen"
        @close="onClose"
    >
        <div class="layout">
            <div class="dialog-header">
                <div class="dialog-title">複製請款單</div>
            </div>
            <div class="dialog-body">
                <div style="display: flex; justify-content: space-between; align-items: center; margin: 10px 30px;">
                    <div>
                        <div>請選擇要一併複製的單據。</div>
                    </div>
                    <div>
                        <el-button size="mini" @click="selectAllReceipt">全選</el-button>
                        <el-button size="mini" @click="deselectAllReceipt">取消全部</el-button>
                    </div>
                </div>
                <div class="receipt-scrollview">
                    <div class="receipt-list">
                        <div class="item" v-for="item in receipts" :key="item.sno" @click="onItemClick($event, item)">
                            <div class="cell-check"><el-checkbox v-model="item.checked"></el-checkbox></div>
                            <div class="cell-picture">
                                <template v-if="item.fileExt === 'jpg' || item.fileExt === 'jpeg' || item.fileExt === 'png' || item.fileExt === 'gif'">
                                    <div class="picture-rect" :style="`background-image: url(${item.file});`"></div>
                                </template>
                                <template v-else>
                                    <div class="picture-rect">
                                        <div class="ext">{{ item.fileExt }}</div>
                                    </div>
                                </template>
                            </div>
                            <div class="cell-content">
                                <div class="receipt-item">
                                    <div class="param" style="margin-bottom: 8px;">
                                        <div class="label">單據類型：</div>
                                        <div class="value" style="font-weight: bold;">{{ item.typeName }}</div>
                                    </div>
                                    <div v-if="item.foo" class="param">
                                        <div class="label">單據號碼：</div>
                                        <div class="value">{{ item.foo }}</div>
                                    </div>
                                    <div v-if="item.companyName" class="param">
                                        <div class="label">賣方公司：</div>
                                        <div class="value">{{ item.companyName }}</div>
                                    </div>
                                    <div v-if="item.amt" class="param">
                                        <div class="label">總額：</div>
                                        <div class="value"><money :v="item.amt" /> {{ payment.cny }}</div>
                                    </div>
                                    <div v-if="item.note" class="param">
                                        <div class="label">備註：</div>
                                        <div class="value">{{ item.note }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding: 15px 30px;">
                    <div style="font-size: 10pt;">共 {{ receipts.length }} 張，已勾選 {{ receipts.filter(item => item.checked).length }} 張，已勾選總額：<money :v="selectedTotalAmt" /> 元</div>
                    <div v-if="isSelectContainsTaxReceipt" style="margin-top: 10px;"><el-alert type="warning" class="warning-text" show-icon :closable="false">勿重複檢附發票單據，避免重複申報。</el-alert></div>
                </div>

            </div>
            <div class="dialog-footer">
                <el-button icon="el-icon-close" @click="onClose">取消</el-button>
                <el-button type="primary" icon="el-icon-right" @click="submit">複製</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>

export default {
    name: 'payment-copy-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        payment: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isLogoAvalible: false,
            receipts: [],
        };
    },
    computed: {
        selectedTotalAmt() {
            let totalAmt = 0;
            this.receipts.forEach((item) => {
                if (item.checked) {
                    totalAmt += item.amt;
                }
            });
            return totalAmt;
        },
        isSelectContainsTaxReceipt() {
            let isContains = false;
            this.receipts.forEach((item) => {
                if (item.checked) {
                    if (item.typ === 1 || item.typ === 2 || item.typ === 3 || item.typ === 10 || item.typ === 11) {
                        isContains = true;
                    }
                }
            });
            return isContains;
        },
    },
    methods: {
        onOpen() {
            // 複製單據資料
            this.receipts = [];
            if (this.payment && this.payment.files && this.payment.files.length > 0) {
                this.payment.files.forEach((file) => {
                    console.log('file', file);

                    // 發票＆有稅額的單據預設不勾選
                    const checked = false;
                    // if (file.filE_TYP === 1
                    //     || file.filE_TYP === 2
                    //     || file.filE_TYP === 3
                    //     || file.filE_TYP === 10
                    //     || file.filE_TYP === 11
                    // ) {
                    //     checked = false;
                    // }

                    this.receipts.push({
                        sno: file.sno,
                        file: file.filE_ATT,
                        typ: file.filE_TYP,
                        typeName: file.filE_TYP_NAM,
                        foo: file.foo,
                        bsn: file.bsn,
                        tax: file.tax,
                        amt: file.amt,
                        note: file.note,
                        companyName: file.companyName,
                        name: file.name,
                        fileExt: file.filE_ATT.split('.').pop(),
                        checked,
                    });
                });
            }
        },
        selectAllReceipt() {
            this.receipts.forEach((item) => {
                // eslint-disable-next-line no-param-reassign
                item.checked = true;
            });
        },
        deselectAllReceipt() {
            this.receipts.forEach((item) => {
                // eslint-disable-next-line no-param-reassign
                item.checked = false;
            });
        },
        onClose() {
            this.$emit('close');
        },
        onItemClick(event, item) {
            // 避免點選到 checkbox 重複觸發事件
            if (event.target.nodeName === 'INPUT') {
                return;
            }
            // eslint-disable-next-line no-param-reassign
            item.checked = !item.checked;
            event.preventDefault();
            event.stopPropagation();
        },
        submit() {
            const name = 'payment-add';
            const query = {
                copyfrom: this.payment.sno,
                receipt: this.receipts.filter((item) => item.checked).map((item) => item.sno),
            };

            console.log('query', query);
            this.$router.push({ name, query });
        },
    },
};

</script>
<style lang="scss">
.payment-copy-dialog.ah-detail-dialog {
    $borderRadius: 20px;
    .el-dialog {
        top: 4vh;
        background-color: #fff;
        width: calc(100% - 10px);
        border-radius: $borderRadius;

        @media (min-width: 720px) {
            max-width: 500px;
        }

        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            padding: 0;
            height: 100%;
        }
    }

    .layout {
        >.dialog-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 30px 30px;
        }

        >.dialog-body {
            min-height: 200px;
        }
        >.dialog-footer {
            display: flex;
            justify-content: flex-end;
            padding: 20px 30px;
        }
    }

    .dialog-title {
        font-size: 14pt;
        font-weight: bold;
    }

    .receipt-scrollview {
        min-height: 100px;
        max-height: 55dvh;
        overflow-y: auto;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        padding: 20px 30px;

        &::-webkit-scrollbar {
            width: 12px;
        }
        &::-webkit-scrollbar-track {
            background: transparent;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #ddd;
            transition: background-color 0.2s;
        }
        &::-webkit-scrollbar-thumb:hover {
            background-color: #ccc;
        }
    }

    .item-list,
    .receipt-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;

        >.item {
            display: grid;
            grid-template-columns: 50px 90px auto;
            background-color: #fff;
            align-items: center;
            border: 2px solid #eee;
            border-radius: 10px;
            cursor: pointer;
            transition: 0.2s;

            &:hover {
                border-color: #ccc;
            }

            &:has(.el-checkbox__input.is-checked) {
                background-color: rgba(77, 68, 181, 0.1);
                border-color: rgba(77, 68, 181, 0.4);
            }

            >.cell-check {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            >.cell-picture {
                padding: 12px 0;

                >.picture-rect {
                    width: 100%;
                    aspect-ratio: 1;
                    border: 1px solid #ccc;
                    border-radius: 5px;
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    >.ext {
                        text-transform: uppercase;
                        color: #ccc;
                        font-size: 10pt;
                    }
                }
            }
            >.cell-content {
                padding: 15px 20px;
                font-size: 9pt;
                height: 100%;
            }
        }
    }

    .receipt-item {
        line-height: 150%;

        >.param {
            display: flex;

            >.label {
                white-space: nowrap;
                display: none;
            }
        }
    }

    .warning-text.el-alert .el-alert__description {
        margin-top: 0;
    }
}
</style>
